import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { map } from 'rxjs/operators';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { TreeData } from 'src/app/data/tree-data.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { of as observableOf } from 'rxjs';
import { Router } from '@angular/router'; 
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ErgebnisDataService } from 'src/app/services/ergebnis-data.service';
import { ErgebnisStorage } from 'src/app/data/ergebnis-storage.model';
import { UserIndikatorenUeberkategorieFilter } from 'src/app/data/user/user-indikatoren-ueberkategorie-filter.model';
import { ConstantsStorage } from 'src/app/immutable/constants-storage';
import { UserBegleitIndikator } from 'src/app/data/user/user-begleit-indikator.model';
import { ConstantsTableCols } from 'src/app/immutable/constants-table-cols';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { FileType, GlobalConstantsRouting, GlobalConstantsSonstige, GlobalConstantsTexte, GlobalFunctions, SessionStorageService } from 'globales-projekt-angular';
import { UserPdfSynopse } from 'src/app/data/user/user-pdf-synopse.model';
import { Synopse } from 'src/app/data/ws/synopse.model';

@Component({
  selector: 'app-ergebnisse',
  templateUrl: './ergebnisse.component.html',
  styleUrls: ['./ergebnisse.component.css'],
})
export class ErgebnisseComponent implements OnInit {
  anwendungsname = ConstantsTexte.ANWENDUNGSNAME;
  faInfoCircle = faInfoCircle;
  faDownload = faDownload;
  faArrowLeft = faArrowLeft;

  isBegleitIndikator: Boolean = false;

  showDoppelte = false;
  allSelected = false;
  downloadAllInOne = false;
  searchValue = '';

  displayedColumns: string[];
  gesamtSumme: number;

  result: TreeData[] = [];
  nestedTreeControl: NestedTreeControl<TreeData>;
  nestedDataSource: MatTreeNestedDataSource<TreeData>;
  dataSource: MatTableDataSource<Synopse> = new MatTableDataSource();

  anzahlMap: Map<string, number> = new Map<string, number>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  synopsen: Synopse[];
  currentSelected: String;
  isParent: Boolean;
  showWaitingForDataSpinner: boolean = false;
  filterValue: string = "";

  constructor(
    private apiService: ApiService,
    private ergebnisDataService: ErgebnisDataService, 
    private router: Router
  ) {}

  _getChildren = (node: TreeData) => observableOf(node.data);
  hasNestedChild = (_: number, nodeData: TreeData) => nodeData.data?.length > 0;

  ngOnInit(): void {
    this.nestedTreeControl = new NestedTreeControl<TreeData>(this._getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();

    if (this.ergebnisDataService.ergebnisStorage != null) {

      this.initData();
      return;
    }

    let ergebnisStorage: ErgebnisStorage = SessionStorageService.getItem(ConstantsStorage.ERGEBNIS_STORAGE);

    if (ergebnisStorage == null) {
      this.router.navigate([GlobalConstantsRouting.MAIN]);
    } else {
      if (ergebnisStorage.isBegleitIndikator) {
        this.showWaitingForDataSpinner = true;

        let userBegleitIndikator: UserBegleitIndikator = SessionStorageService.getItem(ConstantsStorage.USER_BEGLEIT_INDIKATOR);

        this.apiService
          .postBegleitIndikatorErgebnisseListe(userBegleitIndikator)
          .subscribe((response) => {
            ergebnisStorage.synopsen = response;

            this.ergebnisDataService.setErgebnisStorage(ergebnisStorage);

            this.dataSource = new MatTableDataSource(response);

            this.initData();

            this.showWaitingForDataSpinner = false;
          });
      } else {
        this.showWaitingForDataSpinner = true;

        let userIndikatorenUeberkategorieFilter: UserIndikatorenUeberkategorieFilter = SessionStorageService.getItem(ConstantsStorage.USER_INDIKATOREN_UEBERKATEGORIE_FILTER);
        
        this.apiService
          .postIndikatorenErgebnisseListe(userIndikatorenUeberkategorieFilter)
          .subscribe((response) => {
            ergebnisStorage.synopsen = response;

            this.ergebnisDataService.setErgebnisStorage(ergebnisStorage);

            this.dataSource = new MatTableDataSource(response);

            this.initData();

            this.showWaitingForDataSpinner = false;
          });
      }
    }
  }

  initData() {
    this.isBegleitIndikator =
      this.ergebnisDataService.ergebnisStorage.isBegleitIndikator;
    if (this.isBegleitIndikator)
      this.displayedColumns = [
        ConstantsTableCols.DATASET_SELECTED,
        ConstantsTableCols.INDIKATOR_BEZEICHNUNG,
        ConstantsTableCols.INDIKATOR_INFO,
        ConstantsTableCols.QUELLE_INDIKATOR,
        ConstantsTableCols.ID_IND,
        ConstantsTableCols.DOWNLOAD,
      ];
    else
      this.displayedColumns = [
        ConstantsTableCols.DATASET_SELECTED,
        ConstantsTableCols.INDIKATOR_BEZEICHNUNG,
        ConstantsTableCols.INDIKATOR_INFO,
        ConstantsTableCols.QUELLE_INDIKATOR,
        ConstantsTableCols.DIMENSION,
        ConstantsTableCols.ID_IND,
        ConstantsTableCols.DOWNLOAD,
      ];

    this.currentSelected = null;

    this.ergebnisDataService.currentErgebnisse.subscribe(
      (response: Synopse[]) => {
        setTimeout(() => {

          this.refreshData(response, false, false);

          this.synopsen = response;
        }, 0);

        this.gesamtSumme = response.length;

        this.anzahlMap = new Map<string, number>();

        response.forEach((element: Synopse) => {
          let anzahlNutzungsrichtung: number;

          if (this.anzahlMap.has(element.tierkategorie)) {
            anzahlNutzungsrichtung = this.anzahlMap.get(element.tierkategorie);
            anzahlNutzungsrichtung++;
          } else anzahlNutzungsrichtung = 1;

          this.anzahlMap.set(element.tierkategorie, anzahlNutzungsrichtung);

          let anzahlTierart: number;

          if (this.anzahlMap.has(element.tierart)) {
            anzahlTierart = this.anzahlMap.get(element.tierart);
            anzahlTierart++;
          } else anzahlTierart = 1;

          this.anzahlMap.set(element.tierart, anzahlTierart);

        });


      }
    );

    this.ergebnisDataService.currentErgebnisse
      .pipe(
        map((res: any) =>
          res.reduce((acc: Synopse[], val: Synopse) => {
            if (
              !acc.find(
                (el: Synopse) =>
                  el.tierart === val.tierart &&
                  el.tierkategorie === val.tierkategorie
              )
            ) {
              acc.push(val);
            }
            return acc;
          }, [])
        )
      )
      .pipe(
        map((res: any) =>
          res.reduce((r: TreeData[], val: Synopse) => {
            let temp: TreeData = r.find(
              (o: TreeData) => val.tierart === o.tierart
            );

            if (!temp) {
              r.push(
                (temp = {
                  tierart: val.tierart,
                  ausblenden: val.ausblenden,
                  data: [],
                  anzahl: this.anzahlMap.get(val.tierart),
                })
              );
            }

            temp.data.push({
              tierart: val.tierkategorie ? val.tierkategorie : '',
              ausblenden: val.ausblenden,
              data: null,
              anzahl: this.anzahlMap.get(val.tierkategorie),
            });

            return r;
          }, [])
        )
      )

      .subscribe((response: TreeData[]) => {
        this.nestedDataSource.data = response;
      });


  }

  applyFilter(event: any) {
    let filterValue: string = event.target.value;

    this.doFilter(filterValue);
  }

  doFilter(filterValue: string) {
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  searchEntry(
    currentSelected: String,
    isParent: Boolean,
    behalteFilter: Boolean,
    showDoppelte: boolean    
  ) {
    this.showDoppelte = showDoppelte;

    this.searchValue = '';
    this.onClickToggleSelectDataSet(false);
    this.currentSelected = currentSelected;

    this.isParent = isParent;

/*    if (this.isParent) {
      let treeData: TreeData[] = this.nestedDataSource.data;
      for (let entry of treeData) {
        if (entry.tierart === currentSelected)
          if (!this.isBegleitIndikator) {
            if (!entry.ausblenden) this.nestedTreeControl.toggle(entry);
          }
      }
    }*/

    this.ergebnisDataService.currentErgebnisse
      .pipe(
        map((res: any) => {
          let resfinal;

          if (currentSelected == null || isParent == null)
            return res.filter(() => true);

          if (isParent)
            resfinal = res.filter(
              (s: Synopse) => s.tierart === currentSelected
            );
          else
            resfinal = res.filter(
              (s: Synopse) => s.tierkategorie === currentSelected
            );

          return resfinal;
        })
      )
      .subscribe((res: Synopse[]) => {
        this.refreshData(res, behalteFilter, showDoppelte);
      });
    this.allSelected = false;
    this.doFilter(this.filterValue);
  }

  ngAfterViewInit() {
    this.paginator.pageIndex = 0;
    this.dataSource.paginator = this.paginator;
  }

  refreshData(
    synopsen: Synopse[],
    behalteFilter: Boolean,
    showDoppelte: Boolean
  ) {


    let newSynopse: Synopse[] = [];

    if (!showDoppelte) {
      let synopsenSingle = new Map();

      for (let entry of synopsen) {
        if (synopsenSingle.has(entry.idSynopse)) continue;

        synopsenSingle.set(entry.idSynopse, null);
        newSynopse.push(entry);
      }
    } else newSynopse = synopsen;

    let filter: string = '';

    if (this.dataSource != null) filter = this.dataSource.filter;

    this.dataSource = new MatTableDataSource(newSynopse);
    this.ngAfterViewInit();

    this.dataSource.sort = this.sort;

    this.dataSource.filterPredicate = function (
      data: Synopse,
      filter: string
    ): boolean {
      return (
        data.indikatorBeschreibungEins.toLowerCase().includes(filter) ||
        data.indikatorBezeichnung.toLowerCase().includes(filter) ||
        data.dimension.toLowerCase().includes(filter) ||
        data.quelleIndikator.toLowerCase().includes(filter) ||
        data.idInd.toLowerCase().includes(filter)
      );
    };

    if (behalteFilter) {
      this.dataSource.filter = filter;
    }
  }

  onDownloadPdfSynopseSingle(synopse: Synopse) {
    let userPdfSynopse: UserPdfSynopse = new UserPdfSynopse;
    userPdfSynopse.idSynopseListe.push(synopse.idSynopse);
    userPdfSynopse.downloadAllInOne = this.downloadAllInOne;

    this.onDownloadPdfSynopse(userPdfSynopse, synopse.idInd, synopse.tierart);
  }

  onDownloadPdfSynopseMulti(onlyChecked: Boolean) {
    let userPdfSynopse: UserPdfSynopse = new UserPdfSynopse;
    userPdfSynopse.downloadAllInOne = this.downloadAllInOne;

    let idInd: string;
    let tierart: string;

    for (let entry of this.dataSource.filteredData) {
      if (onlyChecked) {
        if (entry.checkedDownload) {
          userPdfSynopse.idSynopseListe.push(entry.idSynopse);
          idInd = entry.idInd;
          tierart = entry.tierart;
        }
      } else userPdfSynopse.idSynopseListe.push(entry.idSynopse);
    }

    if (userPdfSynopse.idSynopseListe.length > 1)
      this.onDownloadPdfSynopse(userPdfSynopse, null, null);
    else if (userPdfSynopse.idSynopseListe.length == 1)
      this.onDownloadPdfSynopse(userPdfSynopse, idInd, tierart);
    else alert(ConstantsTexte.ALARM_KEINE_DATENSAETZE_AUSGEWAEHLT);
  }

  onDownloadPdfSynopse(userPdfSynopse: UserPdfSynopse, idInd: String, tierart: String) {
    if (userPdfSynopse.idSynopseListe.length > ConstantsSonstige.MAX_DOWNLOAD_DATENSAETZE) {
      alert(ConstantsTexte.ALARM_ZU_VIELE_DATENSAETZE);
      return;
    }

    if (userPdfSynopse.idSynopseListe.length > 10) {
      if (
        confirm(
          ConstantsTexte.QUESTION_DATENSAETZE_AUSGEWAEHLT_WIRKLICH_HERUNTERLADEN.replace(
            GlobalConstantsTexte.TEXT_ERSETZUNG_EINS,
            String(userPdfSynopse.idSynopseListe.length)
          ).replace(
            GlobalConstantsTexte.TEXT_ERSETZUNG_ZWEI,
            String(Math.round((userPdfSynopse.idSynopseListe.length * 170) / 1000))
          )
        )
      ) {
      } else return;
    }

    this.showWaitingForDataSpinner = true;

    this.apiService.postPdfSynopse(userPdfSynopse).subscribe((response) => {
      let filename: string;

      if (this.isBegleitIndikator)
        filename = ConstantsSonstige.FILENAME_TIERWOHL_BEGLEITINDIKATOREN;
      else filename = ConstantsSonstige.FILENAME_TIERWOHLINDIKATOR;

      if (userPdfSynopse.idSynopseListe.length > 1 && !userPdfSynopse.downloadAllInOne) {
        filename = filename + ConstantsSonstige.FILENAME_GESAMT;
        GlobalFunctions.downloadFile(
          FileType.ZIP,
          response,
          filename,
          FileType.ZIP_SHORT
        );
      } else {
        if (userPdfSynopse.downloadAllInOne)
          filename = filename + ConstantsSonstige.FILENAME_GESAMT;
        else
          filename = filename + tierart + '-' + idInd;

        GlobalFunctions.downloadFile(
          FileType.PDF,
          response,
          filename,
          FileType.PDF_SHORT
        );
      }

      this.showWaitingForDataSpinner = false;
    });
  }

  onClickToggleSelectDataSet(allSelected: boolean) { 
    let start: number =
      this.dataSource.paginator.pageIndex * this.dataSource.paginator.pageSize;
    let ende: number =
      (this.dataSource.paginator.pageIndex + 1) *
      this.dataSource.paginator.pageSize;
    let counter: number = 0;
 
    for (let entry of this.dataSource.sortData(
      this.dataSource.filteredData,
      this.dataSource.sort
    )) {
      if (counter >= start && counter < ende) {
        entry.checkedDownload = allSelected;
      }

      counter++;
    }


    this.doFilter(this.filterValue);
  }

  onClickToggleOneSelected(oneSelected: boolean) { 

    if (oneSelected) {
      let anzahl: number = 0;

      for (let entry of this.dataSource.filteredData)
        if (entry.checkedDownload) anzahl++;
 
      this.allSelected = anzahl == this.dataSource.filteredData.length;
    } else this.allSelected = false;
  }

  zurAuswahlseite() {
    this.router.navigate([GlobalConstantsRouting.MAIN]);
  }

  getShowTierart(tierart: String): boolean {
    return this.currentSelected == tierart;
  }

  toggleAllInOne() {
    this.downloadAllInOne = !this.downloadAllInOne;
  }

  // https://stackoverflow.com/questions/57790056/collation-for-matsort-with-languages-where-alphabetical-order-is-different-from
  sortData(sort: any) {

    const data: Synopse[] = this.synopsen.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.synopsen = data.sort((a, b) => {
        const isAsc = sort.direction === GlobalConstantsSonstige.ASC;
        switch (sort.active) {
          case ConstantsTableCols.INDIKATOR_BEZEICHNUNG:
            return GlobalFunctions.compareString(
              a.indikatorBezeichnung,
              b.indikatorBezeichnung,
              isAsc
            );
          case ConstantsTableCols.QUELLE_INDIKATOR:
            return GlobalFunctions.compareString(
              a.quelleIndikator,
              b.quelleIndikator,
              isAsc
            );
          case ConstantsTableCols.DIMENSION:
            return GlobalFunctions.compareString(a.dimension, b.dimension, isAsc);
          case ConstantsTableCols.ID_IND:
            return GlobalFunctions.compareString(a.idInd, b.idInd, isAsc);
          default:
            return 0;
        }
      });

    this.dataSource.data = this.synopsen;
    
  }

  pageChanged() {
    let start: number =
      this.dataSource.paginator.pageIndex * this.dataSource.paginator.pageSize;
    let ende: number =
      (this.dataSource.paginator.pageIndex + 1) *
      this.dataSource.paginator.pageSize;
    let counter: number = 0;

    let list: Synopse[] = this.dataSource.sortData(
      this.dataSource.filteredData,
      this.dataSource.sort
    );

    for (let entry of list) {
      if (counter >= start && counter < ende && entry.checkedDownload)
        this.allSelected = true;
      else if (counter >= start && counter < ende && !entry.checkedDownload) {
        this.allSelected = false;
        break;
      }

      counter++;
    }
  }
}

